import { FC } from 'react'
import { ArrowRight } from 'lucide-react'
import CardInfoButton from './CardInfoButton'
import type { CardMeta } from './types'

const pendingMeta: CardMeta = {
  description: 'Actions requiring management attention, such as pending approvals and expiring certifications.',
  endpoint: 'Derived from GET /crew/all and GET /sign/on-off-records/all',
  logic: 'Pending Approvals from crew approvalStatus, Expiring Certs from document names heuristic.',
}

interface PendingAction {
  label: string
  desc: string
  color: 'warning' | 'danger' | 'success'
}

interface Props {
  items: PendingAction[]
  onActionClick: (label: string) => void
}

const PendingActions: FC<Props> = ({ items, onActionClick }) => {
  const bgMap: Record<string, string> = { warning: 'bg-amber-50 border-amber-200', danger: 'bg-red-50 border-red-200', success: 'bg-emerald-50 border-emerald-200' }
  const txtMap: Record<string, string> = { warning: 'text-amber-600', danger: 'text-red-600', success: 'text-emerald-600' }
  const dotMap: Record<string, string> = { warning: 'bg-amber-500', danger: 'bg-red-500', success: 'bg-emerald-500' }

  return (
    <div className='flex flex-col flex-1 bg-white rounded-2xl border border-slate-200 shadow-sm p-4 md:p-5'>
      <div className='flex items-center justify-between mb-4'>
        <h6 className='text-sm font-bold text-slate-900'>Pending Actions</h6>
        <CardInfoButton meta={pendingMeta} />
      </div>
      <div className='flex-1 space-y-2'>
        {items.map((action, i) => (
          <div
            key={i}
            className={`flex items-center gap-3 p-3 rounded-xl border cursor-pointer transition-colors hover:bg-slate-50 ${bgMap[action.color]} ${action.color !== 'success' ? 'cursor-pointer' : 'cursor-default'}`}
            onClick={() => action.color !== 'success' && onActionClick(action.label)}
          >
            <span className={`w-2 h-2 rounded-full flex-shrink-0 ${dotMap[action.color]}`} />
            <div className='flex-1 min-w-0'>
              <div className='text-[11px] font-semibold text-slate-800'>{action.label}</div>
              <div className='text-[10px] text-slate-500'>{action.desc}</div>
            </div>
            {action.color !== 'success' && (
              <ArrowRight className='w-3.5 h-3.5 text-slate-400 flex-shrink-0' />
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default PendingActions
